<div class="flex-content" style="align-items:center;">
    <div style="min-height:20px;padding-top:10px;">
        <div *ngIf="loginSettings.DistrictLogo != null">
            <a [href]="loginSettings.DistrictURL" target="_blank" aria-label="District Logo">
                <img style="height:80px;" src="data:image/jpg;base64,{{loginSettings.DistrictLogo}}" />
            </a>
        </div>
    </div>
    <label class="districtName" *ngIf="loginSettings.DisplayDistrictNameOnLoginPage">{{ loginSettings.DistrictName }}</label>
    <div class="box">
        <tabs *ngIf="loginSettings.DisplaySeparateUserTypes" [tabNames]="tabNames" (tabChange)="tabChange($event)"></tabs>
        <div class="center">
                <h2 class="tyl-color-green-light" (click)="setTabs()">Login Assistance</h2>
                <a (click)="forgotPasswordClick()">
                    Reset Your&nbsp;
                    <span *ngIf="!loginSettings.V10">
                            <span *ngIf="loginSettings.TabSpecificForgotPasswordLink">
                                    <span *ngIf="userType == 1">Staff</span>
                                    <span *ngIf="userType == 2">Parent</span>
                                    <span *ngIf="userType == 3">Student</span>
                                    &nbsp;Password
                            </span>
                            <span *ngIf="!loginSettings.TabSpecificForgotPasswordLink">Login Information?</span>
                    </span>
                    <span *ngIf="loginSettings.V10">Password</span>            
                </a>
                <a (click)="forgotUserNameClick()" *ngIf="loginSettings.V10 || userType != 2">
                    Email Your Username
                </a>
        </div>
    </div>
    <div style="padding-top:10px;" [innerHTML]="loginSettings.LoginAssistMessage | safeHtml"></div>
</div>

<login-footer></login-footer>